// Post-mission review collection. Replace the Place ID with the one from your Google Business Profile.
export const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=REPLACE_WITH_GOOGLE_PLACE_ID";

export const REVIEW_WA_MSG = {
  en: "Hello Book & Smile, a few words about my experience: ",
  fr: "Bonjour Book & Smile, quelques mots sur mon expérience : ",
};

export const THANK_YOU = {
  en: {
    seoTitle: "Thank you | Book & Smile",
    eyebrow: "Thank you",
    h1a: "It was a pleasure",
    h1b: "to handle it.",
    text: "If we made your time in Paris easier, a few words from you would help other international clients find us. It takes a minute. Your name is never published without your written permission.",
    google: "Leave a Google review",
    wa: "Send a few words on WhatsApp",
    note: "Prefer to stay private? A WhatsApp message is enough — we will only quote you if you say so.",
    back: "Back to Book & Smile",
  },
  fr: {
    seoTitle: "Merci | Book & Smile",
    eyebrow: "Merci",
    h1a: "Ce fut un plaisir",
    h1b: "de nous en occuper.",
    text: "Si nous avons rendu votre temps à Paris plus simple, quelques mots de votre part aideront d'autres clients internationaux à nous trouver. Une minute suffit. Votre nom n'est jamais publié sans votre accord écrit.",
    google: "Laisser un avis Google",
    wa: "Envoyer quelques mots sur WhatsApp",
    note: "Vous préférez rester discret ? Un message WhatsApp suffit — nous ne vous citerons que si vous le souhaitez.",
    back: "Retour à Book & Smile",
  },
};
